import classNames from "classnames";
import { FC, useContext, useRef } from "react";
import NotificationDispatch, { showErrorNotification } from "../context/notificationContext";
import useOnClickOutside from "../hooks/useOnclickOutside";
import useToggle from "../hooks/useToggle";
import { useI18n } from "../hooks/useTranslations";
import { useMeApi } from "../http/me/api";
import { LanguageCode } from "../types";
import SvgGermany from "./flags/Germany";
import SvgItaly from "./flags/Italy";
import SvgUk from "./flags/UnitedKingdom";
import SvgUsa from "./flags/Usa";
import styles from "./LanguageSelector.module.css";

const LanguageSelector: FC = () => {
  const i18n = useI18n();
  const meApi = useMeApi();
  const { isOpen, close, toggle } = useToggle();
  const dispatch = useContext(NotificationDispatch);
  const languageSelectorRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(languageSelectorRef, () => isOpen && close());

  const submitLanguage = async (language: LanguageCode) => {
    try {
      i18n.setLanguage(language);
      await meApi.updateMyLanguage({ preferredLanguage: language });
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    }
  };

  return (
    <>
      <div className={styles.container}>
        <button
          type="button"
          className={classNames(styles.button, styles["current-flag"], { [styles.open]: isOpen })}
          onClick={toggle}
        >
          {i18n.language === "it-IT" ? (
            <SvgItaly />
          ) : i18n.language === "de-DE" ? (
            <SvgGermany />
          ) : i18n.language === "en-US" ? (
            <SvgUsa />
          ) : (
            <SvgUk />
          )}
          <div className="ripple-container"></div>
        </button>
      </div>
      <div
        ref={languageSelectorRef}
        className={classNames(styles.languageDropdown, isOpen ? styles.visible : undefined)}
      >
        <ul>
          <li onClick={() => submitLanguage("it-IT")}>
            <SvgItaly />
            <span>{i18n.t.common.italian}</span>
          </li>
          <li onClick={() => submitLanguage("de-DE")}>
            <SvgGermany />
            <span>{i18n.t.common.german}</span>
          </li>
          <li onClick={() => submitLanguage("en-UK")}>
            <SvgUk />
            <span>{i18n.t.common.english} (UK)</span>
          </li>
          <li onClick={() => submitLanguage("en-US")}>
            <SvgUsa />
            <span>{i18n.t.common.english} (US)</span>
          </li>
        </ul>
      </div>
    </>
  );
};

export default LanguageSelector;
